<template>
  <div class="navigation">
    <div class="navMain myMain">
      <div class="logo" @click="scrollTop">
        <img :src="logoUrl" alt="LUNA AI" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      logoUrl: require('@/assets/pc/LUNA-AI-logo.png')
    }
  },
  methods: {
    scrollTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped lang="less">
.navigation {
  width: 100%;
  background-color: #f6f8f7;
  position: fixed;
  top: 0;
  z-index: 9999;
}
.navMain {
  height: 1.44rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  overflow: visible;
}
.logo {
  width: 4.5rem;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 100%;
  }
}
</style>
